import React, { useState } from 'react';
import SectionBanner from '../../components/Banner';
import './businessSeries.css';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// Components
import { LightRoundBtn } from '../../helper/buttons';
import { CustomTypoH1, CustomTypoH2, CustomTypoPara } from '../../helper/headings';
// Mui icon
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import BusinessSeriesCard from '../../components/business_series_card';
import ReqDemoAndSignupSection from '../../components/req_demo_or_signup_section';
// SVGs
import BusinessSeries1SVG from '../../assets/business series_1.svg';
import BusinessSeries2SVG from '../../assets/business series_2.svg';
import BusinessSeries3SVG from '../../assets/business series_3.svg';
import AppNavBar from '../../helper/appbar';

const BusinessSeries = () => {
    const [submitStatus, setSubmitStatus] = useState({ sign: "Register", isLoading: false });

    const submitForm = (event) => {
        event.preventDefault();
        setSubmitStatus({ sign: "", isLoading: true });
        setTimeout(() => {
            setSubmitStatus({ sign: "Details recieved", isLoading: false });
        }, 6000);
    };

    return (
        <div className="business_series_main">
            <AppNavBar navType={'_light'} />
            {/* Custom banner */}
            <SectionBanner
                title={'Business Series'}
                tagline={'The best online resources for African businesses by Africans'}
            />

            <section className='business-series__section2'>
                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} className='business-series__sub1'>
                            {/* <img src={require('../../assets/Rectangle540-hotel.png')} alt='Rectangle540-hotel' /> */}
                            <img src={BusinessSeries1SVG} alt='Rectangle540-hotel' />
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} xl={6} className='business-series__sub2'>
                            <LightRoundBtn title={"Upcoming Session"} bg="#E8F0FF" />
                            <CustomTypoH1 typo={"Leveraging The Right Tool For Your Business Travel"} />
                            <div className='date-grid'>
                                <CalendarMonthOutlinedIcon sx={{ color: '#655F5F' }} />
                                <h5>September 02, 2022 | 11 am</h5>
                            </div>
                            <CustomTypoPara typo={"Kardinal Business Series interviews top African business professionals, where they discuss different problems and sustainable solutions for businesses, especially in Africa."} />
                            <CustomTypoPara typo={"As part of this discussion, we will examine innovative solutions that can be applied to existing ones in order to help businesses maximize their output."} />
                            <button>
                                <a href="#register_form">
                                    Register Now
                                    <ExpandCircleDownIcon />
                                </a>
                            </button>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className='business-series__section3'>
                <LightRoundBtn title={"Previous Sessions"} bg="#D3D4F8" />
                <CustomTypoH2 typo={"Catch all the highlights on our business series"} />

                <div className='business-series-card-list'>
                    <BusinessSeriesCard
                        image={BusinessSeries2SVG}
                        date={'November 17, 2021 | 11 am'}
                        des={'Step up your business using bleisure programs with Oluchi Obiejesi and Yyvonne Joseph.'}
                        spotify={"https://open.spotify.com/episode/2XaIc8LTCCfcLPjyO01YHK?si=yDV_RWpCRlqZ7bI7gDnODg"}
                        apple={"https://podcasts.apple.com/ng/podcast/step-up-your-business-using-bleisure-programs-with/id1586156609?i=1000542334923"}
                        google={"https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82YWQ5MjUxNC9wb2RjYXN0L3Jzcw/episode/NDNlMjMxMzQtY2RlYS00NDRiLThlNjMtMjUzZjJlZDY3Yjky?sa=X&ved=0CAUQkfYCahcKEwjQycTxwqP6AhUAAAAAHQAAAAAQNQ"}
                        youtube={"https://www.youtube.com/watch?v=qgggwwTyrMk&t=1389s&ab_channel=Kardinal"}
                    />
                    <BusinessSeriesCard
                        image={BusinessSeries3SVG}
                        date={'September 08, 2021 | 11 am'}
                        des={'Improving employee engagement and experience with Modupe Bankole and Temitope Aina'}
                        spotify={"https://open.spotify.com/episode/4TWWzEXa9rtjzSRGzHoFll?si=p_d7kM52TkePRbWoQHI9XQ"}
                        apple={"https://podcasts.apple.com/ng/podcast/improving-employee-engagement-and-experience-with/id1586156609?i=1000535541989"}
                        google={"https://podcasts.google.com/feed/aHR0cHM6Ly9hbmNob3IuZm0vcy82YWQ5MjUxNC9wb2RjYXN0L3Jzcw/episode/ZGQzNTQzMjItYWQyMC00NGFjLTlhMjUtMTUxYmQ3MDlkZjdl?sa=X&ved=0CAUQkfYCahcKEwjQycTxwqP6AhUAAAAAHQAAAAAQNQ"}
                        youtube={"https://www.youtube.com/watch?v=BNjj6Y-4HF0&t=44s"}
                    />
                </div>
            </section>

            <section className='business-series__section4' id="register_form">
                <Container fluid>
                    <Row>
                        <Col xs={12} sm={12} md={6}>
                            <CustomTypoH1 typo={`Get front seats to our next business series.`} />
                            <p className='business-series__section4_para'>Sign up and you will be the first to know when we host our next Corporate Live Series</p>
                        </Col>
                        <Col xs={12} sm={12} md={6}>
                            <div className='business-series__registration_form'>
                                <input placeholder='Full name' />
                                <input placeholder='Email' />
                                <button onClick={submitForm} disabled={submitStatus.sign === "Details recieved"}>
                                    {submitStatus.isLoading ?
                                        <CircularProgress
                                            size={30}
                                            sx={{ marginTop: 1, color: "#d9d9d9" }}
                                        />
                                        :
                                        submitStatus.sign
                                    }
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <ReqDemoAndSignupSection
                title={`Supercharge your business with the right travel tools`}
                signUpBtn={`Sign up for free`}
                signUpBtnMobile={`Sign up`}
                reqDemoBtn={`Request Demo`}
            />
        </div>
    );
};

export default BusinessSeries;